module.exports = __webpack_public_path__ + "static/media/neutron_and_blue.69ef05fd.png";